import React from 'react';
import './PublicBreadcrumb.scss';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const PublicBreadcrumb = ({ className, steps, activeStep, threedots }) => {
    return <div className={className ? 'PublicBreadcrumb ' + className : 'PublicBreadcrumb'}>
        <ul className={!threedots ? 'PublicBreadcrumb__ul' : 'PublicBreadcrumb__ul threedots'}>
            {steps.map((step, i) =>
                <li key={i} className='PublicBreadcrumb__ul__li'>
                    <Link to={step.path} className={activeStep === step.name ? 'PublicBreadcrumb__ul__li--link activeStep' : 'PublicBreadcrumb__ul__li--link'}>
                        {step.name}
                    </Link>
                </li>
            )}
        </ul>
    </div>;
};

export default PublicBreadcrumb;

PublicBreadcrumb.propTypes = {
    className: PropTypes.string,
    steps: PropTypes.array.isRequired,
    activeStep: PropTypes.string.isRequired,
    threedots: PropTypes.bool
};
